export default __webpack_public_path__ + "static/media/banner.f3f99152.jpg";